import { RouteTableColumn } from '../route-function-report/route-analysis-report/route-analysis-report.models';
export const VEHICLE_WORK_COLUMNS: RouteTableColumn[] = [
  { field: 'strFullName', title: 'نام خودرو' }, { field: 'strDate', title: 'تاریخ' },
  { field: 'strSTime', title: 'زمان شروع' }, { field: 'strETime', title: 'زمان پایان' },
  { field: 'strFunction', title: 'زمان کل', totalField: 'iFunction', totalDuration: true },
  { field: 'strAbsoulatFunction', title: 'زمان حرکت', totalField: 'iAbsoulatFunction', totalDuration: true },
  { field: 'strParkTime', title: 'زمان توقف', totalField: 'iParkTime', totalDuration: true },
  { field: 'fGasPer100', title: 'مصرف سوخت (litre)', numeric: true, totalField: 'fGasPer100', unit: 'لیتر' },
  { field: 'Distance', title: 'میزان پیمایش (km)', numeric: true, totalField: 'Distance', unit: 'کیلومتر' },
];
